export default __webpack_public_path__ + "static/media/2508111.7b81f220.png";